module.exports = __webpack_public_path__ + "img/ring_y_0_0_null.a997f6d9.png";